/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, Button, Alert,
} from 'reactstrap';

import classnames from 'classnames';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { useHistory } from 'react-router-dom';

import {
  Formik, Field, FieldArray, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { get, post } from '../../helpers/api_helper';

function ZebraForm(props) {
  const {
    entity,
    t,
  } = props;
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const save = async (values) => {
    try {
      setLoading(true);
      setErrorMessage(null);
      let result;
      if (entity.id === undefined) {
        result = await post('/api/zebra/create', values);
      } else {
        result = await post(`/api/zebra/save/${entity.id}`, values);
      }

      toastr.success(t(`Item ID ${result.id} saved`), t('Success'));
      props.onSuccess(result);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    name: Yup
      .string()
      .required(props.t(t('Name is required'))),
  });

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const jsx = (
    <>
      { em }
      <Formik
        enableReinitialize
        initialValues={entity}
        validationSchema={ValidationSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({
          touched, errors, values, setFieldValue,
        }) => (
          <Form className="mt-3" id="ZebraPrinterForm" autoComplete="off">
            {Object.entries(errors).length > 0 && (
              <Alert color="danger">{t('Form contains errors')}</Alert>
            )}
            <div className="row mt-4 mb-4">
              <Label
                for="printer_name"
                className="col-sm-3 col-form-label"
              >
                {props.t('Printer Name')}
              </Label>
              <Col sm={9}>
                <Field className="form-control" id="printer_name" name="name" />
                <ErrorMessage
                  name="name"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="printer_ip"
                className="col-sm-3 col-form-label"
              >
                {props.t('IP Address')}
              </Label>
              <Col sm={9}>
                <Field className="form-control" id="printer_ip" name="ip" />
                <ErrorMessage
                  name="ip"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="printer_port"
                className="col-sm-3 col-form-label"
              >
                {props.t('TCP Port')}
              </Label>
              <Col sm={9}>
                <Field className="form-control" id="printer_port" name="port" />
                <ErrorMessage
                  name="port"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

ZebraForm.defaultProps = {
  entity: {
    name: '',
    ip: '',
    port: 0,
  },
  onSuccess: () => {},
};

ZebraForm.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default connect((state) => ({

}), {})(withTranslation()(ZebraForm));
